<template>
<div>
  <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
    日志信息
  </h3>
  <el-table
    :data="tableData"
    stripe
    border
    style="width: 100%">
    <el-table-column
      prop="title"
      label="标题">
    </el-table-column>
    <el-table-column
      prop="account"
      label="管理员帐号">
    </el-table-column>
    <el-table-column
      prop="loginTime"
      label="登录时间">
    </el-table-column>
    <el-table-column
      prop="loginIP"
      label="登录IP">
    </el-table-column>
    <el-table-column
      prop="loginArea"
      label="登录位置">
    </el-table-column>
    <el-table-column
      label="是否异地登录">
      <template slot-scope="scope">
        <span v-if="scope.row.diffAreaLogin==='y'">是</span>
        <span v-if="scope.row.diffAreaLogin==='n'">否</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="block">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</div>
</template>

<script>
  export default {
    name: "LogList",
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.loadData('?current='+val+'&size='+this.pageSize);
      },
      flushPage(){
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      loadData(params) {
        const self = this
        let postData =
          self.$qs.stringify({
          })
        if(!params){
          params = '';
        }
        self.$http.post(self.$host+'log/page'+params,
          postData
        ).then(function (response) {
          self.tableData = response.data.content.records;
          self.currentPage = response.data.content.current;
          self.pageSize = response.data.content.size;
          self.total = response.data.content.total;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        tableData:[],
        currentPage: 1,
        pageSize:10,
        total:1,
      };
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/LogList.vue